// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"a03f2823","1418":"85641c18","2808":"f34e0124","3190":"6c02370e","4715":"6c02370e","6513":"f94f0740","7186":"56246eb7","7569":"9b0cb96b","8245":"56246eb7"}[chunkId] + ".chunk.css";
};